// src/components/Genestandardinjtmolding.js
import React from 'react';

import Standardinje from './standardinje'; 
import Generalservise from './Generalservise';
import Bjservice from './Bjservice';
import Jeservice from './Jeservice';
import Dpservice from './Dpservice';
import Productspecial from './Productspecial';
import PetPreform from './PetPreform';
import Create from './Create';
import Medicalp from './Medicalp';
import Twoprod from './Twoprod';
// import Requestps from './Requestps';
import Bjstandard from './Bjstandard';
import Machanedetail from './Machanedetail';
import Secmachanedetail from './Secmachanedetail';
import Machanedteable from './Machanedteable';
import Injectiounit from './Injectiounit';
import Powerunite from './Powerunit'; 
import General from './General';

const Genestandardinjtmolding = () => {
  return (
    <div>
      <Standardinje />
      <Generalservise />
      <Bjservice />
      <Jeservice />
      <Dpservice />
      <Productspecial />
      <PetPreform />
      <Create />
      <Medicalp />
      <Twoprod />
      {/* <Requestps /> */}
      <Bjstandard />
      <Machanedetail />
      <Secmachanedetail />
      <Machanedteable />
      <Injectiounit />
      <Powerunite />
      <General />
    </div>
  );
};

export default Genestandardinjtmolding;
